module.exports = __webpack_public_path__ + "images/404.1789608252531.png";